import MenuContent from './MenuContent';
import TextAndIconWithSpecialWrapping from './TextAndIconWithSpecialWrapping';

export { TextAndIconWithSpecialWrapping };
export default MenuContent;
